import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response, ResponseContentType} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {environment} from 'environment';

@Injectable()
export class VoucherGenRepository {

  constructor(private http: Http) { }

  public generateVouchers(amount: number): Observable<Blob> {
    const headers: Headers = new Headers({'Content-Type': 'application/json'});
    const options: RequestOptions = new RequestOptions({
      headers: headers,
      withCredentials: true,
      responseType: ResponseContentType.Blob,
    });

    return this.http.post(`${environment.voucherGen}/${amount}`, null, options)
      .map((response: Response) => {
        return response.blob();
      });
  }

  public validateCode(code: string): Observable<boolean> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.voucherValid}/${code}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public invalidateCode(code: string): Observable<string> {
    const headers: Headers = new Headers({'Content-Type': 'application/json'});
    const options: RequestOptions = new RequestOptions({headers: headers, withCredentials: true});

    return this.http.put(`${environment.voucherInvalidate}/${code}`, null, options)
      .map((response: Response) => {
        return response.json();
      });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/voucher/voucher-gen/repositories/voucher-gen.repository.ts